import { render, staticRenderFns } from "./BusChangeRequests.vue?vue&type=template&id=21161a7d&scoped=true&"
import script from "./BusChangeRequests.vue?vue&type=script&lang=js&"
export * from "./BusChangeRequests.vue?vue&type=script&lang=js&"
import style0 from "./BusChangeRequests.vue?vue&type=style&index=0&id=21161a7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21161a7d",
  null
  
)

export default component.exports